import { type FC } from 'react';
import { motion, type Variants } from 'framer-motion';

import {
  endEffectAnimationVariant,
  startEffectAnimationVariant,
} from './config';

interface InitViewProps {
  animationVariant: 'start' | 'end';
}

const InitView: FC<InitViewProps> = ({ animationVariant }) => {
  const effectAnimationVariants: Variants = {
    start: startEffectAnimationVariant,
    end: endEffectAnimationVariant,
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      variants={effectAnimationVariants}
      animate={animationVariant}
      className="absolute w-full h-full flex items-center justify-center z-[2] pointer-events-none"
    >
      <motion.div className="w-full h-full relative">
        <div className="absolute inset-0 w-full h-full bg-black backdrop-blur"></div>
        <div className="absolute inset-0 w-full h-full bg-[#FF0000]/20 backdrop-blur"></div>
        <div className="absolute inset-0 w-full h-full border-[24px] border-[#FF0000] blur-[32px]"></div>
        <div className="absolute inset-0 w-full h-full border-[8px] border-[#FF0000] blur-[12px]"></div>
      </motion.div>
    </motion.div>
  );
};

export { InitView };
